import { render, staticRenderFns } from "./festival.vue?vue&type=template&id=fbbbecf0"
import script from "./festival.vue?vue&type=script&lang=js"
export * from "./festival.vue?vue&type=script&lang=js"
import style0 from "./festival.vue?vue&type=style&index=0&id=fbbbecf0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbbbecf0')) {
      api.createRecord('fbbbecf0', component.options)
    } else {
      api.reload('fbbbecf0', component.options)
    }
    module.hot.accept("./festival.vue?vue&type=template&id=fbbbecf0", function () {
      api.rerender('fbbbecf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/festival.vue"
export default component.exports